/* eslint-disable jsx-a11y/anchor-is-valid */
const Setup = () => {
  return (
    <>
      {/* saved from url=(0051)https://getbootstrap.com/docs/4.0/examples/pricing/ */}
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {/* Meta Title */}
      <title>
        Norton Antivirus Activation &amp; Support | Redeem Product Key &amp;
        Contact Support
      </title>
      {/* Meta Description */}
      <meta name="description" content="PCScancare" />
      {/* Meta Keywords */}
      <meta name="keywords" content="PCScancare" />
      {/* Meta Robots */}
      <meta name="robots" content="index, follow" />
      {/* Open Graph Meta Tags (for social media sharing) */}
      <meta property="og:title" content="PCScancare" />
      <meta property="og:description" content="EPCScancare" />
      <meta property="og:image" content="" />
      <meta property="og:url" content="www.pcscancare.com" />
      <meta property="og:type" content="website" />
      {/* Twitter Card Meta Tags (for Twitter sharing) */}
      <meta name="twitter:title" content="PCScancare" />
      <meta name="twitter:description" content="PCScancare" />
      <meta name="twitter:image" content="" />
      <meta name="twitter:card" content="summary_large_image" />
      {/* Canonical Link */}
      <link rel="canonical" href="www.pcscancare.com" />
      <link rel="icon" href="assets/img/nlok.ico" />
      {/* Bootstrap core CSS */}
      <link href="assets/bootstrap.min.css" rel="stylesheet" />
      {/* Custom styles for this template */}
      <link href="assets/form.css" rel="stylesheet" />
      <div className="header-section border-bottom box-shadow">
        <div className="container">
          <div className="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 bg-white ">
            <h5 className="my-0 mr-md-auto font-weight-normal">
              <img src="/mainlogo.jpeg" alt="My account" />
            </h5>
          </div>
        </div>
      </div>
      <div className="main">
        <div className="cover-section vh-100 py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-0 col-lg-6 d-flex justify-content-center align-items-center flex-column d-none-991 text-center">
                <h1 style={{ color: "white" }}>
                  Protection trusted <br />
                  by millions.
                </h1>
                <img src="assets/img/awards.png" width="400" alt="My account" />
              </div>
            </div>
          </div>
        </div>
        <div className="container my-5">
          <div className="motto-wrap" />
          <div className="divider" />
          <div className="home-content-wrap">
            <div className="w-layout-grid about-grid cc-about-2">
              <div id="w-node-76c147234d41-7e8c90d3">
                <div className="home-section-wrap">
                  <h2 className="section-heading">
                    How to enter Norton setup Product key? <br />
                  </h2>
                  <p className="paragraph-light">
                    The moment you purchase Norton via Norton.com/setup, you
                    will there and then get the product key on your email id
                    that is linked with your Norton account. <br />
                    <br />
                    However, if you have purchased Norton setup via the retail
                    shop, then you will get the product key on the backside of
                    the redeem card that you will get in the antivirus package
                    that you receive. To{" "}
                    <a href="#">
                      <strong>enter the Product key</strong>
                    </a>{" "}
                    you just have to firstly, install the Norton setup from the
                    official website and once the file is installed, open Norton
                    by double-click on its icon on the desktop. Now, click on
                    the “Activate” option and enter the Norton Product Key from
                    the email and then click on the “Norton products and
                    Subscription”. <br />
                  </p>
                </div>
                <div className="home-section-wrap">
                  <h2 className="section-heading">
                    How to reinstall Norton Internet Security? <br />
                  </h2>
                  <p className="paragraph-light">
                    If you wish to reinstall the Norton setup on your device
                    then you firstly, have to visit Norton.com/setup and then
                    sign in to your Norton account which you have already
                    created by tapping on the “{" "}
                    <a href="#">
                      <strong>Sign In</strong>
                    </a>
                    ” option. Once you have signed in, you can select the Norton
                    product that you have installed earlier. <br />
                    <br />
                    Here, you just have to check whether your Norton
                    subscription is still active or not. Therefore, if your
                    Norton Subscription is expired then you are requested to
                    renew it as soon as possible to avail of the uninterrupted
                    security services. You have to make sure that you have the
                    updated latest version of Norton via{" "}
                    <a href="#">
                      <strong>norton.com/setup</strong>
                    </a>
                    . <br />
                  </p>
                </div>
                <div className="home-section-wrap">
                  <h2 className="section-heading">
                    How to set up a Norton account via norton.com/setup? <br />
                  </h2>
                  <p className="paragraph-light">
                    First of all, it is important to understand that setting up
                    a Norton account is not a complex process. You just have to
                    visit{" "}
                    <a href="#">
                      <strong>www.norton.com/setup</strong>
                    </a>{" "}
                    via web browser and then tap in the “Sign In” option present
                    on the top of the web page. <br />
                    <br />
                    You will be redirected to a page that will show you two
                    options: Log in and Sign up. If you are a new user, just
                    click on the “Sign up” option and follow the on-screen
                    instructions.
                  </p>
                </div>
                <div className="home-section-wrap">
                  <h3 className="section-heading">
                    Is it important to uninstall old Norton to install the new
                    version? <br />
                  </h3>
                  <p className="paragraph-light">
                    If you are thinking about installing the latest version of
                    Norton on your device, then, first of all, you need to
                    uninstall the previous version of it. It is so because there
                    are some product versions that may not support the upgrading
                    and they create interruptions in the downloading process of
                    Norton antivirus. <br />
                    <br />
                    You just need to remember, the new version will not be
                    similar to the latest one so, you need to be a little
                    calculative in installing the latest version of Norton
                    setup. Also, make sure the latest version matches the device
                    compatibility. Furthermore, uninstalling the temporary and
                    junk files is also an important part of the process for
                    successful completion of the same. Visit norton.com/setup.{" "}
                    <br />
                  </p>
                </div>
                <div className="home-section-wrap">
                  <h3 className="section-heading">
                    How to download Norton using a product key? <br />
                  </h3>
                  <p className="paragraph-light">
                    First of all, you should understand that downloading Norton
                    antivirus on your laptop or PC is not a complex task. For
                    this, you just have to visit norton.com/setup via a web
                    browser and download the Norton setup. Make sure, you check
                    whether there is any other antivirus or firewall installed
                    on your machines or not. If you already have an antivirus
                    installed on your device then Norton downloading process
                    will show you an error. To get rid of this error, you have
                    to make sure that there is no other antivirus solution; if
                    you have then you have to delete it from your device. <br />
                    <br />
                    So, you have to visit norton.com/setup and tap on the “Sign
                    In” option and enter the credentials associated with the
                    Norton account. Once the process to download is completed,
                    you can install the Norton using the product key and then
                    activate it on Mac and PC. <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="py-4 border-top">
          <div className="container d-flex justify-content-between align-items-center">
            <p style={{ fontSize: 12 }}>
              Copyright © 2024 Gen Digital Inc. All rights reserved.
            </p>
            <img src="assets/img/main-logo-1.svg" alt="My account" />
          </div>
        </footer>
      </div>
      {/* Bootstrap core JavaScript
    ================================================== */}
      {/* Placed at the end of the document so the pages load faster */}
      <grammarly-desktop-integration data-grammarly-shadow-root="true">
        <template shadowrootmode="open" />
      </grammarly-desktop-integration>
    </>
  );
};

export default Setup;
